import React, { useCallback, useEffect, useState } from "react";
import { LoaderPage, NotFound } from "../../../pages";
import { useAuthActions } from "../../../store/actions-context";
interface IDomainProviderProps {
  children: React.ReactNode;
  domain?: string;
}

export const DomainProvider = ({
  children,
  domain = "",
}: IDomainProviderProps): JSX.Element => {
  const { checkDomainAction } = useAuthActions();

  const [isDomainCorrect, setIsDomainCorrect] = useState(false);
  const [checkDomainLoading, setCheckDomainLoading] = useState(true);

  const domainChecks = useCallback(async () => {
    try {
      await checkDomainAction(domain);
      setIsDomainCorrect(true);
    } finally {
      setCheckDomainLoading(false);
    }
  }, [domain]);

  useEffect(() => {
    domainChecks();
  }, [domain]);

  if (checkDomainLoading) return <LoaderPage loading={checkDomainLoading} />;

  if (isDomainCorrect) return <>{children}</>;

  return <NotFound />;
};
